import BTButton from "@common-components/bt-button/bt-button";
import { UserInterface } from "@common-models/user";
import { Alert, Box, Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useState } from "react";
import { runAccountDeletion } from "./delete-account";
import { modalActions } from "@common-reducers/ModalReducer";
import { selectUserObject } from "@common-reducers/UserSelectors";
import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook";
import { sendEmailToAdminWhenUserDeletesAccount, logoutWrapperThunk } from "@/common/reducers/UserThunks";
import { useDeleteUserAccountMutation } from "@common-reducers/backend-api/backend-api";
import { useTranslation } from 'react-i18next';
import { namespace } from '@common/config/constants';





export const DeleteAccountModal = () => {
    const { t } = useTranslation(namespace);
    const dispatch = useAppDispatch();
    // get current user id
    const user: UserInterface | undefined = useAppSelector(selectUserObject);
    const accessToken = useAppSelector((state) => state.UserReducer.accessToken);
    const [deleteUserAccount] = useDeleteUserAccountMutation();
    const [errorReason, setErrorReason] = useState<string | null>(null);
    const [isDeleting, setIsDeleting] = useState(false);

    const handleCloseDeleteDialog = () => {
        dispatch(modalActions.setComponentToRender(''));
    }

    const deleteUser = async () => {
        setErrorReason(null);
        setIsDeleting(true);
        const outcome = await runAccountDeletion({ deleteAccount: () => deleteUserAccount({ userId: user?._id ?? '' }).unwrap() });
        setIsDeleting(false);

        if (outcome.status === 'failed') {
            // Keep the modal open and the session intact: nothing (or not everything) was deleted.
            console.error('Error deleting user account:', outcome.reason);
            setErrorReason(outcome.reason);
            return;
        }

        // The account is gone: notify admin, close the modal and use the app's normal logout path.
        dispatch(sendEmailToAdminWhenUserDeletesAccount({userId: user?._id ?? ''}));
        handleCloseDeleteDialog();
        dispatch(logoutWrapperThunk({ accessToken: accessToken ?? null }));
    }

    return (
        <>
            <DialogTitle>{t('deleteAccountModal.title')}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Box>{t('deleteAccountModal.confirmMessage')}</Box>
                    <Box sx={{ color: "red" }}>{t('deleteAccountModal.irreversibleWarning')}</Box>
                </DialogContentText>
                {errorReason && <Alert severity="error" sx={{ mt: 2 }} data-testid="delete-account-error">{t('deleteAccountModal.errorMessage', 'We could not delete your account. Nothing was changed, you are still logged in. Please try again or contact support.')}</Alert>}
            </DialogContent>
            <DialogActions >

                <Button color="secondary" sx={{ textTransform: "capitalize", mr: 2 }} onClick={deleteUser} disabled={isDeleting}>{t('common.delete')}</Button>
                <BTButton onClick={handleCloseDeleteDialog} variant="contained">{t('common.cancel')}</BTButton>
            </DialogActions>
        </>

    )

}




